<script lang="ts" setup>
const { t } = useI18n()
</script>

<template>
  <div class="relative flex flex-col">
    <div class="h-auto md:h-149.25">
      <div class="mt-36.5 mx-5 md:mt-39 md:mx-0">
        <div
          class="text-white text-center text-2xl leading-10.5 tracking-wide relative z-1 md:text-[2.125rem]"
        >
          {{ t('a-growth-hack') }}
          <span class="text-[#FFB0F0]">{{ t('growth-hack') }}</span>
          {{ t('for-your-community') }}
        </div>
        <div
          class="mt-10 mb-18.5 text-center text-lg leading-[1.75rem] tracking-wide text-[#CECECE] relative z-1 md:max-w-163.5 md:mx-auto"
        >
          {{ t('raffle-mint-passes-among') }}
        </div>
      </div>
      <div
        class="flex items-center justify-center absolute top-0 left-0 right-0 z-0 mt-5.5 h-49 md:mt-19 md:h-97.5"
      >
        <NuxtImg
          loading="lazy"
          :alt="
            t('a-growth-hack') +
            ' ' +
            t('growth-hack') +
            ' ' +
            t('for-your-community')
          "
          class="max-w-351 w-full h-49 md:h-97.5 object-cover object-center"
          src="/images/home/community.webp"
        />
      </div>
    </div>
  </div>
</template>
